<template>
    <div>
      <div v-if="Object.keys(smsLogs).length > 0">
        <div v-for="(group, date) in smsLogs" :key="date">
          <div class="row mobile-p-bottom-0 mobile-m-left-16">
              <div class="clearfix"></div>
            <div class="col-md-offset-3 col-md-6 created-date">
              {{ date }}
            </div>
          </div>
          <div></div>
          <sms-log-row v-for="(log, index) in group" :log="log" :twilio-account-number="twilioAccountNumber" :key="index"></sms-log-row>
        </div>
      </div>
    </div>
</template>

<script>
import moment from "moment-timezone";
import EmailLogRow from "./EmailLogRow.vue";

export default {
    name: "SmsLogTable",
  components: {EmailLogRow},
    props: {
        smsLogs: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        dateTimeObj:{
            type:Object,
            required:true
        },
        twilioAccountNumber:{
            type: String,
            default: () => null,
        }
    },

}
</script>
<style scoped>
.created-date{
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
    color: rgb(98, 112, 124);
}
@media (max-width: 991px) {
  .mobile-p-bottom-0 {
    padding-bottom: 0px;
  }
  .mobile-m-left-16 {
    margin-left: 16px;
  }
}
</style>